
        Component.define('hero', (el, params) => {
            const $el             = $(el);
const $btnVideo       = $el.find('.btn-video');
const $modalVideo     = $el.find('.modal-video');
const $elVideo        = $el.find('.video-foreground');
const $elBg           = $el.find('.video-background');
const $btnClose       = $el.find('.btn-close');
const $embed          = $el.find('iframe');

let player;

$document.on('yt.ready', function () {
    player = new YT.Player($embed.get(0));
});

function closeModal () {
    if (player) {
        console.log(player);
        player.stopVideo();
    }

    TweenMax.to($elVideo, .6, {top: '200%'});
    TweenMax.to($modalVideo, .6, { opacity: 0, display: 'none' });
}

$btnVideo.on('click', function () {
    TweenMax.to($modalVideo, .5, { display: 'block', opacity: 1 });
    TweenMax.to($elVideo, .5, { top: '50%' });
});

$btnClose.add($elBg).on('click', function () {
    closeModal();
});

$document.keydown(function (e) {
    if (e.key === "Escape") {
        closeModal();
    }
})

        });